/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 47);
/******/ })
/************************************************************************/
/******/ ({

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(48);


/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(49);

$(function() {
    // $('.gray-box-bar li').click(function(e) {
    //     e.preventDefault();
    //     console.log("点到了",e)
    // })

    // if(window.orientation==90||window.orientation==-90){
    //     　    console.log("横屏状态！")
    // }else if(window.orientation==0||window.orientation==180){
    // 　console.log("竖屏状态！")
    // }
    // var width = document.documentElement.clientWidth;
    // var height = document.documentElement.clientHeight;
    // console.log("width",width)
    // console.log("height",height)

    var bookblock = $('#bb-bookblock');
    function setHeight() {
        var width = window.innerWidth ;
        var height =  window.innerHeight;
        var h = arguments[0]
          ? width
          : height;
        bookblock.height(611*h/750);
        bookblock.css({top: 68*h/750 + 'px'});

    }
    setHeight();
    $(window).resize(function() {
      var width = window.innerWidth ;
      var height =  window.innerHeight;
      setHeight(width<height);
    })

    var width = window.innerWidth ;
    var height =  window.innerHeight;
    $('#J_text').hide().html(width + '----' + height);
    if( width < height ) {//一开始竖屏
        $print =  $('.print');
        $print.width(height);
        $print.height(width);
        $print.css('top',  (height-width)/2 );
        $print.css('left',  0-(height-width)/2 );
        $print.css('transform' , 'rotate(90deg)');
        $print.css('transform-origin' , '50% 50%');
        $print.css('transition' , '100ms linear 100ms');
        setHeight(true);
        setTimeout(function() {
          setHeight(true);
        }, 800);
    }else{//一开始横屏
        $print =  $('.print');
        $print.width(width);
        $print.height(height);
        $print.css('top',  0 );
        $print.css('left',  0 );
        $print.css('transform' , 'none');
        $print.css('transform-origin' , '50% 50%');
        $print.css('transition' , '100ms linear 100ms');

    }

    var evt = "onorientationchange" in window ? "orientationchange" : "resize";
        window.addEventListener(evt, function() {
            window.location.reload();
            return;
            var width = window.innerWidth ;
            var height =  window.innerHeight;
            if(width > height ) {
              $('#shade-suo').show();
              $('#initmodal').show();
            } else {
              $('#shade-suo').hide();
              $('#initmodal').hide();
            }
            //console.log(evt,"evt");
            //  console.log(width + " " + height,"width3")
            //$print =  $('.print');
            //  if( width > height ){
            //       console.log("1111",evt)
            //     $print.width(width);
            //     $print.height(height);
            //     $print.css('top',  0 );
            //     $print.css('left',  0 );
            //     $print.css('transform' , 'rotate(90deg)');
            //     $print.css('transform-origin' , '50% 50%');
            //     $print.css('transition' , '100ms linear 100ms');

            //  }
            //  else{
            //      console.log("22222",evt)
            //     console.log(width + " " + height,"width4")

            //     $print.width(height);
            //     $print.height(width);
            //     // $print.css('top',  0 );
            //     // $print.css('left',  0 );
            //     $print.css('top',  (height-width)/2 );
            //     $print.css('left',  0-(height-width)/2 );
            //     $print.css('transform' , 'none');
            //     $print.css('transform-origin' , '50% 50%');
            //     $print.css('transition' , '100ms linear 100ms');
            //  }
            if(window.orientation==90||window.orientation==-90){
                var width = window.innerWidth;
                var height =  window.innerHeight;
                console.log("横屏状态！")
                console.log(width + " " + height,"width32")
                $print.width(height);
                $print.height(width);
                $print.css('top',  0 );
                $print.css('left',  0 );
                $print.css('transform' , 'none');
                $print.css('transform-origin' , '50% 50%');
                $print.css('transition' , '100ms linear 100ms');
                setHeight(true);
                setTimeout(function() {
                  setHeight(true);
                }, 1000);

            }else if(window.orientation==0||window.orientation==180){
                var width = window.innerWidth;
                var height =  window.innerHeight;
            　  console.log("竖屏状态！")
                console.log(width + " " + height,"width42")
                $print.width(width);
                $print.height(height);
                $print.css('left',  (height-width)/2 );
                $print.css('top',  0-(height-width)/2 );
                $print.css('transform' , 'rotate(90deg)');
                $print.css('transform-origin' , '50% 50%');
                $print.css('transition' , '100ms linear 100ms');
                setHeight();
            }
        }, false)
})


/***/ }),

/***/ 49:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

/******/ });


// WEBPACK FOOTER //
// mobileindex.js